import React, { useState, useEffect } from 'react';
import { UserGroupIcon, UserCircleIcon } from '@heroicons/react/24/outline';
import baseUrl from '../../config';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

// Material-UI Imports
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack'; // For Alert to display nicely, though not strictly necessary for a single Alert

const MyInstructors = () => {
    const [coursesData, setCoursesData] = useState([]);
    const navigate = useNavigate();
    const [snackbarOpen, setSnackbarOpen] = useState(false); // State for Snackbar visibility

    const instructors = [
        { border: 'border-indigo-400' },
    ];

    const fetchUpcomingCourses = async () => {
        try {
            const response = await axios.get(`${baseUrl}api/students/enrolled-courses`, {
                headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
            });
            setCoursesData(response.data);
        } catch (error) {
            console.error('Error fetching courses:', error);
        }
    };

    useEffect(() => {
        fetchUpcomingCourses();
    }, []);

    // Helper to get initials
    const getInitials = (name) => {
        if (!name) return '';
        const nameParts = name.split(' ');
        if (nameParts.length > 1) {
            return (nameParts[0][0] + nameParts[1][0]).toUpperCase();
        }
        return nameParts[0][0].toUpperCase();
    };

    const handleTeacherProfileNavigation = () => {
        if (coursesData && coursesData[0]?.enrollmentTeacherId) {
            navigate(`/teacher/profile/${coursesData[0].enrollmentTeacherId}`);
        }
    };

    // Function to handle message button click and open Snackbar
    const handleMessageClick = () => {
        setSnackbarOpen(true); // Open the Snackbar
    };

    // Function to close the Snackbar
    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; // Prevents closing when clicking outside the Snackbar
        }
        setSnackbarOpen(false); // Close the Snackbar
    };

    return (
        <div className="bg-white rounded-2xl p-6 shadow-glass border-b-4 border-emerald-600 transition-all duration-300 hover:shadow-xl hover:scale-[1.01]">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 flex items-center">
                <UserGroupIcon className="w-8 h-8 mr-3 text-emerald-600" />
                My Instructors
            </h2>
            <ul className="space-y-4">
                {coursesData.length > 0 && (
                    <li className="flex items-center space-x-4 bg-gray-50 p-4 rounded-xl shadow-sm hover:bg-gray-100 transition-all duration-200">
                        {/* {coursesData[0]?.img ? ( */}
                            <img
                                className={`w-16 h-16 rounded-full object-cover border-4 ${instructors[0].border} flex-shrink-0`}
                                src={coursesData[0].img}
                                // alt={`${coursesData[0].teacherName} Profile`}
                            />
                        {/* ) : (
                            <div className={`w-16 h-16 rounded-full flex items-center justify-center bg-gray-300 text-gray-600 text-xl font-bold border-4 ${instructors[0].border} flex-shrink-0`}>
                                {coursesData[0]?.teacherName ? getInitials(coursesData[0].teacherName) : <UserCircleIcon className="w-10 h-10 text-gray-500" />}
                            </div>
                        )} */}
                        <div className="flex-grow">
                            <p className="font-bold text-lg text-gray-800"> {coursesData[0]?.teacherName || 'Instructor Name'}</p>
                            <p className="text-gray-600 text-sm">Teaches: {coursesData[0]?.course?.title || 'Course Title'}</p>
                        </div>
                        <button
                            onClick={handleMessageClick}
                            className="bg-emerald-600 text-white px-3 py-1.5 rounded-full text-sm font-semibold hover:bg-emerald-700 transition-colors"
                        >
                            Message
                        </button>
                    </li>
                )}
            </ul>
            <button
                onClick={handleTeacherProfileNavigation}
                className="mt-4 w-full bg-emerald-600 text-white py-2 rounded-full font-semibold hover:bg-emerald-700 transition-colors shadow-md"
            >
                View Teacher Profile
            </button>

            {/* Material-UI Snackbar for the message */}
            <Snackbar open={snackbarOpen} autoHideDuration={3000} onClose={handleSnackbarClose}>
                <Alert onClose={handleSnackbarClose} severity="info" sx={{ width: '100%' }}>
                    This service is not available yet.
                </Alert>
            </Snackbar>
        </div>
    );
};

export default MyInstructors;